import React, { Fragment } from 'react'
import PropTypes from 'prop-types'

import { PLACEMENT_POSITIONS } from 'utils/constants/components/popover'
import { LIST_SIZES, LIST_TYPES } from 'utils/constants/components/dropdown'
import { Dropdown } from 'components/dropdown'
import { List } from 'components/list'
import { DefaultTriggerRenderer } from 'components/dropdown/components/defaultTriggerRenderer/DefaultTriggerRenderer'
import { DefaultRowRenderer } from 'components/dropdown/components/defaultRowRenderer/DefaultRowRenderer'
import { RepositionDropdown } from 'components/dropdown/components/reposition/RepositionDropdown'

const LIST_MAX_HEIGHT = 300
const LIST_ROW_HEIGHT_REGULAR = 40
const LIST_ROW_HEIGHT_COMPACT = 24

export const DropdownListView = props => {
  const {
    // dropdown
    className,
    dataTestId,
    onClose,
    placement,
    width,

    // common
    size = 'regular',
    titleKey = 'title',
    type = 'primary',
    value,

    // trigger
    isDisabled,
    isMultiSelect,
    isValid = true,
    multiSelectTitle,
    placeholder,
    triggerElementRenderer = DefaultTriggerRenderer,

    // list
    closeOnSelect = true,
    handleIsRowSelected,
    listItems,
    onRowClick,
    rowHeight,
    rowRenderer = DefaultRowRenderer,

    // reposition
    keysToPositionUpdate = ['listItems'],
  } = props
  const listRowHeightBySize = size === 'compact' || size === 'small' ? LIST_ROW_HEIGHT_COMPACT : LIST_ROW_HEIGHT_REGULAR
  const listRowHeight = rowHeight || listRowHeightBySize
  const listHeightByRows = listItems.length * listRowHeight
  const listMaxHeight = listHeightByRows > LIST_MAX_HEIGHT ? LIST_MAX_HEIGHT : listHeightByRows
  const propsToPositionUpdate = {}

  keysToPositionUpdate.forEach(key => {
    propsToPositionUpdate[key] = props[key]
  })

  return (
    <Dropdown
      className={className}
      dataTestId={dataTestId}
      onClose={onClose}
      triggerElementRenderer={triggerElementRenderer({
        isDisabled,
        isMultiSelect,
        isValid,
        multiSelectTitle,
        placeholder,
        size,
        titleKey,
        type,
        value,
      })}
      width={width}
      placement={placement}>
      {({ handlePopoverToggle, scheduleUpdate }) => (
        <Fragment>
          <RepositionDropdown {...propsToPositionUpdate} scheduleUpdate={scheduleUpdate} />

          <List
            className={size}
            list={listItems}
            onRowClick={({ item }) => {
              onRowClick({ item })
              closeOnSelect && handlePopoverToggle()
            }}
            rowRenderer={({ item }) => rowRenderer({ size, item, titleKey })}
            height={listMaxHeight}
            isRowSelected={handleIsRowSelected}
          />
        </Fragment>
      )}
    </Dropdown>
  )
}

DropdownListView.propTypes = {
  // dropdown
  className: PropTypes.string,
  dataTestId: PropTypes.string,
  onClose: PropTypes.func,
  placement: PropTypes.oneOf(PLACEMENT_POSITIONS),
  width: PropTypes.number,

  // common
  size: PropTypes.oneOf(LIST_SIZES),
  titleKey: PropTypes.string,
  type: PropTypes.oneOf(LIST_TYPES),
  value: PropTypes.oneOfType([PropTypes.object, PropTypes.array, PropTypes.string]),

  // trigger
  isDisabled: PropTypes.bool,
  isMultiSelect: PropTypes.bool,
  isValid: PropTypes.bool,
  multiSelectTitle: PropTypes.string,
  triggerElementRenderer: PropTypes.func,
  placeholder: PropTypes.string,

  // list
  closeOnSelect: PropTypes.bool,
  handleIsRowSelected: PropTypes.func,
  listItems: PropTypes.array,
  onRowClick: PropTypes.func,
  rowHeight: PropTypes.number,
  rowRenderer: PropTypes.func,

  // reposition
  keysToPositionUpdate: PropTypes.array,
}
